import React from 'react'
import { shape, array, oneOf } from 'prop-types'
import { stores } from '../../../stores'
import { InquiryTypes } from '../../../constants/InquiryTypes'
import { InquiryFrequencies } from '../../../constants/InquiryFrequencies'
import { InquiryDetailsProposalCount } from '../../../components/inquiries/InquiryDetailsProposalCount'
import { InquiryDetailsProposal } from '../../../components/inquiries/InquiryDetailsProposal'

import { ProposalsActions } from './ProposalsActions'

/**
 * Proposals block listing for visits
 */
export const ProposalsWaiting = ({ inquiry, type, frequency }) => (
  <div className='demandes__section'>
    <InquiryDetailsProposalCount count={inquiry.proposals ? inquiry.proposals.length : 0} />
    {
          inquiry.proposals.map((p) => (
            <InquiryDetailsProposal key={p.id} proposal={p} only={stores.inquiries.selected} type={type} frequency={frequency}>
              <ProposalsActions id={inquiry.id} isMaintenance={inquiry.isMaintenance} proposal={p} />
            </InquiryDetailsProposal>
          ))
        }
  </div>
)
ProposalsWaiting.propTypes = {
  inquiry: shape({
    proposals: array
  }),
  type: oneOf(Object.values(InquiryTypes)),
  frequency: oneOf(Object.values(InquiryFrequencies))
}



// WEBPACK FOOTER //
// ./src/pages/demandes/visits/ProposalsWaiting.js